import React, { useMemo, useState } from 'react';
import './css/index.scss';
import { useDispatch } from 'react-redux';
import MyModal from '../../../../components/MyModal';
import { EVENT_MODAL_STATES } from '../../constants';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';
import { removeEvent, updateEvent } from '../../../../store/actions/events';

function EventModal({
  isVisible, setIsVisible, modalState, selectedEvent = {}, setSelectedEvent,
  selectedEvents, setSelectedEvents, getEvents,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const modalTextPart = useMemo(() => {
    if (selectedEvents?.length) return `выбранные мероприятия (${selectedEvents.length})`;
    return 'это мероприятие';
  }, [selectedEvents]);

  const closeModal = () => {
    if (loading) {
      return;
    }
    setIsVisible(false);
    setTimeout(() => {
      setSelectedEvent({});
    }, 400);
  };

  const afterRequestIfManyEvents = () => {
    setSelectedEvents([]);
    getEvents?.({ paramsPage: 1, isInitRequired: false });
    closeModal();
  };

  const onActiveChange = (newActiveVal) => async () => {
    const payload = {
      event_id: selectedEvent._id,
      event_ids: selectedEvents || [],
      is_active: newActiveVal,
    };

    const data = await sendRequest({
      request: Api.blockEvent,
      payload,
      warnErrorText: 'while blocking event',
      setLoading,
    });

    if (data?.status === 'ok') {
      if (selectedEvents?.length) {
        return afterRequestIfManyEvents();
      }
      dispatch(updateEvent({ ...selectedEvent, is_active: newActiveVal }));
      closeModal();
    }
  };

  const onDeleteClick = async () => {
    if (selectedEvents?.length) {
      setLoading(true);
      let allOk = true;
      for (let i = 0; i < selectedEvents.length; i += 1) {
        const data = await sendRequest({
          request: Api.deleteEvent,
          payload: { id: selectedEvents[i] },
          warnErrorText: 'while deleting event',
        });
        if (data?.status !== 'ok') {
          allOk = false;
          break;
        }
      }
      setLoading(false);
      if (allOk) {
        afterRequestIfManyEvents();
      }
      return;
    }

    const data = await sendRequest({
      request: Api.deleteEvent,
      payload: { id: selectedEvent._id },
      warnErrorText: 'while deleting event',
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(removeEvent({ ...selectedEvent }));
      closeModal();
    }
  };

  return (
    <MyModal isOpen={isVisible} closeFunction={closeModal}>
      <div className="event_modal">
        {modalState === EVENT_MODAL_STATES.block ? (
          <>
            <p className="modal_title">Забанить?</p>
            <p className="modal_info_name">
              {selectedEvents?.length ? `Выбранные мероприятия (${selectedEvents.length})` : selectedEvent.name}
            </p>
            <p className="modal_info">{`Вы уверены что хотите отправить ${modalTextPart} в бан-лист?`}</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Забанить"
                loading={loading}
                onClick={onActiveChange(false)}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.fullyDelete ? (
          <>
            <p className="modal_title">Удалить?</p>
            <p className="modal_info_name">
              {selectedEvents?.length ? `Выбранные мероприятия (${selectedEvents.length})` : selectedEvent.name}
            </p>
            <p className="modal_info">{`Вы уверены что хотите удалить ${modalTextPart}?`}</p>
            <p className="modal_info">Отменить данное действие будет невозможно</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Удалить"
                loading={loading}
                onClick={onDeleteClick}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.makeActive ? (
          <>
            <p className="modal_title">Разбанить?</p>
            <p className="modal_info_name">{selectedEvent.name}</p>
            <p className="modal_info">Вы уверены что хотите снять это мероприятие из бан-листа?</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Разбанить"
                loading={loading}
                onClick={onActiveChange(true)}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.changeData ? (
          <>myau</>
        )
          : null}

      </div>
    </MyModal>
  );
}

export default EventModal;
